<script>
import Cookies from "js-cookie";
import {notificationMethods, levelMethods} from "@/state/helpers";
import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Levels",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      itemsLoaded: false,
      items: [],
      currentUser:JSON.parse(Cookies.get('user')),
      title: "Kurlar Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kurlar",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal:false,
      formError:'',
      editFormError:'',
      addForm: {
        name: null,
        title: null,
        description: null,
      },
      editForm: {
        name: null,
        title: null,
        description: null,
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search:'',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label:'Kur',
          sortable: true,
        }, {
          key: "title",
          label:'Başlık',
          sortable: true,
        }, {
          key: "description",
          label:'Açıklama',
          sortable: true,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput:1
    };
  },
  validations: {
    addForm: {
      name: {required},
      title: {required},
      description: {required},
    },
    editForm: {
      name: {required},
      title: {required},
      description: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch:{
    page(newPage){
      this.pageInput=newPage;
      this.getLevels(newPage);
    },
    search(newSearch){
      if(newSearch.length<1){
        if(this.page===1){
          this.getLevels();
        }else{
          this.page=1;
        }
      }
    },
    'addForm.email':function(){
      this.addForm.email= this.turkishToLower(this.addForm.email)
    },
    'editForm.email':function(){
      this.editForm.email= this.turkishToLower(this.editForm.email)
    }
  },
  mounted() {
    this.getLevels();
  },
  methods: {
    ...levelMethods,
    ...notificationMethods,
    doSearch(){
      if(this.page===1){
        this.getLevels();
      }else{
        this.page=1;
      }
    },
    resetForm() {
      this.addForm.name = null;
      this.addForm.title = null;
      this.addForm.description = null;
      this.editForm = {
        name: null,
        title: null,
        description: null,
      };
      //
      this.addSubmitted = false;
      this.editSubmitted=false;
    },
    getLevels(page=this.page){
      this.itemsLoaded=false;
      let filter={}
      if(this.filter){
        filter.name = this.filter;
      }
      this.fetchLevels({page,limit:this.perPage,search:this.search}).then(res=>{
        this.totalRows = res.total;

        this.items = res.docs.map(elem=>{
          return elem;
        })
        this.itemsLoaded=true;
      })
    },
    handleSubmit() {
      this.addSubmitted = true;
      this.formError="";
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
        this.createLevel({
          ...this.addForm,
        }).then(()=>{
          this.toastMessage="Kur başarıyla eklendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.getLevels();
          this.addForm.name = "";
          this.addForm.title = "";
          this.addForm.description = "";
        }).catch((err)=>{
          if(err=='TCNUMBER_ALREADY_USE'){
            this.formError="Girilen TC numarasına sahip bir Kur bulunmaktadır."
          }else{
            this.toastMessage="Sistemde bir hata oluştu!";
            this.toastAction="error";
            this.showToast=true;
            setTimeout(()=>{
              this.showToast=false;
            },3000)
          }
        })
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError=""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        this.updateLevel({
          id: this.editId,
          data: {
            ...this.editForm,
          },
        }).then(()=>{
          this.toastMessage="Kur başarıyla düzenlendi!";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.editModal = false;
          this.getLevels();
        }).catch((err)=>{
          if(err=='TCNUMBER_ALREADY_USE'){
            this.editFormError="Girilen TC numarasına sahip bir Kur bulunmaktadır."
          }else{
            this.toastMessage="Sistemde bir hata oluştu!";
            this.toastAction="error";
            this.showToast=true;
            setTimeout(()=>{
              this.showToast=false;
            },3000)
          }
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteLevel(this.deleteId).then(()=>{
        this.deleteModal = false;
        this.toastMessage="Kur başarıyla silindi!";
        this.toastAction="success";
        this.showToast=true;
        setTimeout(()=>{
          this.showToast=false;
        },3000)
        this.getLevels();
      })
    },
    openEdit(level) {
      this.editForm.name = level.name;
      this.editForm.title = level.title;
      this.editForm.description = level.description;
      this.editId = level.id;
      this.editModal = true;
    },
    openDelete(level) {
      if(level.email===this.currentUser.email){
        this.noDeleteModal=true;
      }else{
        this.deleteId = level.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str){
      let letters = { "İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç" };
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function(letter){ return letters[letter]; })
      return str.toLowerCase();
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>

                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Kur Ekle
                </button>
              </div>
            </div>
            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{new Date(data.item.createdAt).toDateString()}}
                  </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'levelDetail',params:{levelId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"  class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="md" v-model="showModal" title="Kur Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Kur</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Kur  giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Kur  girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Başlık</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.title"
                    class="form-control"
                    placeholder="Başlık giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.title.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.title.required"
                    class="invalid-feedback"
                >
                  Başlık girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Açıklama</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.description.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.description.required"
                    class="invalid-feedback"
                >
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kur Ekle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="ms" v-model="editModal" title="Kur Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Kur </label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Kur  giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Kur  girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Başlık</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.title"
                    class="form-control"
                    placeholder="Başlık giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.title.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.title.required"
                    class="invalid-feedback"
                >
                  Başlık girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Açıklama</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.description"
                    class="form-control"
                    placeholder="Açıklama giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.description.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.description.required"
                    class="invalid-feedback"
                >
                  Açıklama girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div
                v-if="editFormError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç</b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kur Düzenle</b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu kuru silmek istediğinize emin misiniz? Silinmiş kuru geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız kuru silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
